module.exports = __webpack_public_path__ + "static/img/2.13fb97d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/eng/2.png
// module id = 60e4
// module chunks = 0